import { Ruler, MapPin, Landmark, Search, TrendingUp, Lightbulb } from "lucide-react";
import { PALETTE } from "../lib/theme";

// Eye-candy loader replicating the original mockup's checklist.
// Items are purely visual; the backend call is a single request.
const ITEMS = [
  { Icon: Ruler,      label: "Collecte des données locales…",          color: PALETTE[0] },
  { Icon: MapPin,     label: "Cartographie des commerces…",             color: PALETTE[1] },
  { Icon: Landmark,   label: "Analyse des équipements environnants…",   color: PALETTE[2] },
  { Icon: Search,     label: "Détection des manques…",                  color: PALETTE[3] },
  { Icon: TrendingUp, label: "Analyse des interdépendances…",           color: PALETTE[4] },
  { Icon: Lightbulb,  label: "Génération des recommandations…",         color: PALETTE[4] },
];

export function ProgressChecklist() {
  return (
    <ul
      role="status"
      aria-live="polite"
      className="mt-5 flex flex-col gap-3"
    >
      {ITEMS.map(({ Icon, label, color }, i) => (
        <li key={i} className="flex items-center gap-2.5 text-sm text-slate-500">
          <Icon size={16} color={color} strokeWidth={1.8} />
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}
